import {DateTime} from "luxon";
import {socket} from "app/api/socket";

let lastTimeNotified = DateTime.now();

export const notifyTyping = (receiverId: number) => (dispatch: any): any => {
	if (-lastTimeNotified.diffNow(['seconds']).seconds < 2) return;
	lastTimeNotified = DateTime.now();
	return socket.notifyTyping(receiverId);
}
